import { createSlice } from "@reduxjs/toolkit";
import { getCaseToCaseHospital } from "@custom/rtk-apis/Setting/creditForCaseToCase/getCaseToCaseHospital";

const initialState = {
  status: "",
  data: [],
  msg: "",
  loading: false,
  error: "",
};

const getCaseToCaseHospitalSlice = createSlice({
  name: "getCaseToCaseHospitalSlice",
  initialState,
  reducers: {
    clearGetCaseToCaseHospitalState: (state) => {
      state.status = '';
      state.data = [];
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCaseToCaseHospital.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCaseToCaseHospital.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status || "SUCCESS";
        state.data = payload.data || [];
        state.msg = payload.msg || "";
      })
      .addCase(getCaseToCaseHospital.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
        state.status = "FAILED";
      });
  },
});

export default getCaseToCaseHospitalSlice.reducer;
export const { clearGetCaseToCaseHospitalState } = getCaseToCaseHospitalSlice.actions;
